


















import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import Modal from '@/components/poultry/Modal.vue';
import VueRouter from 'vue-router';
import { ToastProgrammatic as Toast } from 'buefy';
import { clientStores } from '@/store/poultry/client';

@Component({
  components: {
    Modal
  }
})
export default class DeleteClient extends Vue {
  store = clientStores.details;
  showDeleteModal = false;

  async handleDeleteClient() {
    try {
      await this.store.delete();
      if (this.store.isDeleted) {
        this.$router.push({
          name: 'clients'
        });
        Toast.open({
          type: 'is-danger',
          message: 'Client deleted',
        });
      }
    } catch(error) {
      Toast.open({
        type: 'is-danger',
        message: 'Client cannot be deleted',
      });
    }
  }

  @Emit('onClose')
  closeDeleteModal() {}
}
